import React, { ReactNode, useContext, useEffect, useState } from 'react';

import SoftwareContext from '@totem/components/devices/software/softwareContext';
import { Software } from '@totem/components/devices/software/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const SoftwareContainer = ({ id, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<Software[]>([]);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<Software>(null);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      const uri = `${DEVICES_ENDPOINT}/${id}/software`;

      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: Software[]) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id, refreshData, getApiToken]);

  const handleAction = (newAction: string, item: Software) => {
    switch (newAction) {
      default:
        setAction(newAction);

        setActionItem(item);
    }
  };

  return (
    <SoftwareContext.Provider
      value={{
        deviceId: id,
        loading: isLoading,
        data,
        action,
        actionItem,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </SoftwareContext.Provider>
  );
};

export default SoftwareContainer;
